import React from 'react';
import { useInView } from 'react-intersection-observer';

import { getThemeClass } from '../../tools/textTools';
import ContentfulImage from '../Common/ContentfulImage';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import PageSection from './PageSection';
import * as styles from './ZPattern.module.scss';

const ZPatternBlock = ({ content }) => {
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  return (
    <div
      data-analytics-component={'z-pattern-block'}
      data-analytics-id={content.title}
      className={[styles.zPatternBlock, inView ? styles.inView : ''].join(' ')}
      ref={ref}
    >
      <ContentfulImage imageFragment={content.image} lazy={true} className={styles.image} />
      <div className={styles.copy}>
        {content.title && <h3>{content.title}</h3>}
        <RichTextConverter copy={content.copy} />
      </div>
    </div>
  );
};

export default function ZPattern({ section }) {
  let bgColor;

  switch (section.backgroundColor) {
    case 'lilac deep':
      bgColor = styles.lilacDeep;
      break;
    default:
      break;
  }

  const themeClass = getThemeClass(section.colorTheme?.themeName);

  return (
    <PageSection slim className={[styles.section, bgColor, themeClass].join(' ')} data-analytics-section={'z-pattern'}>
      {section.title && <h2>{section.title}</h2>}
      <div className={[styles.content, section.flip ? styles.flip : ''].join(' ')}>
        {section?.content?.map((content, i) => (
          <ZPatternBlock content={content} key={i} />
        ))}
      </div>
    </PageSection>
  );
}
